import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { AccordionPanelGroupProvider } from './AccordionPanelGroup.Context/provider.es.js';

const AccordionPanelGroup = ({ size, onCard, children })=>{
    return jsx(AccordionPanelGroupProvider, {
        onCard: onCard,
        size: size,
        children: jsx("div", {
            className: classNames('cb-accordion-panel-group', size, {
                card: onCard
            }),
            children: children
        })
    });
};
AccordionPanelGroup.displayName = 'AccordionPanelGroup';

export { AccordionPanelGroup };
//# sourceMappingURL=AccordionPanelGroup.es.js.map
